import {createRouter, createWebHistory, createWebHashHistory} from "vue-router";
import routes from "@/routing/routes";

const router = createRouter({
    history: process.env.IS_ELECTRON ? createWebHashHistory() : createWebHistory(),
    routes,
});

export default router;